// base
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
// grid
import { AgGridModule } from 'ag-grid-angular/main';
// Material Design
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// dropdown
import { NgbDropdownModule } from './dropdown/dropdown.module';
// Accordion
import { NgbAccordionModule } from './accordion/accordion.module';
// FileUploa
import { FileUploadModule } from 'ng2-file-upload';

import { GridButtonRenderComponent } from './render/grid-button-render.component';
import { GridSelectRendererComponent } from './render/grid-select-renderer.component';
import { GridDoubleButtonRendererComponent } from './render/grid-double-button-renderer.component';

import {
  MdButtonModule,
  MdCardModule,
  MdCheckboxModule,
  MdDialogModule,
  MdIconModule,
  MdInputModule,
  MdListModule,
  MdRadioModule,
  MdSidenavModule,
  MdSelectModule,
  MdToolbarModule,
  MdProgressBarModule,
  MdAutocompleteModule,
  MdDatepickerModule,
  MdNativeDateModule,
  MdTooltipModule,
  MdTabsModule
} from '@angular/material';
// file uploader
// import { FileUploader } from 'ng2-file-upload';
// custom module
import { AppRoutingModule } from './app-routing.module';
// Custom helper classes
import { DataSource } from './classes/dataSource/dataSource';
import { PostDataSource } from './classes/dataSource/postDataSource';
import { ExportData } from './classes/exportData/exportData';
// custom service
import { AbcService } from './service/abc/abc.service';
import { AccountBookService } from './service/account-book/account-book.service';
import { AuthHashkeyService } from './service/auth-hashkey/auth-hashkey.service';
import { AuthLoginService } from './service/auth-login/auth-login.service';
import { AuthLogoutService } from './service/auth-logout/auth-logout.service';
import { AuthRefreshService } from './service/auth-refresh/auth-refresh.service';
import { ArrivePlanService } from './service/arrive-plan/arrive-plan.service';
import { ArriveResultService } from './service/arrive-result/arrive-result.service';
import { BookStockService } from 'app/service/book-stock/book-stock.service';
import { CarrierService } from './service/carrier/carrier.service';
import { CaseService } from './service/case/case.service';
import { ClientReportService } from './service/client-report/client-report.service';
import { CommonService } from './service/common/common.service';
import { CreateFormService } from './service/create-form/create-form.service';
import { CsvReportService } from './service/csv-report/csv-report.service';
import { DeliAreaService } from './service/deli-area/deli-area.service';
import { DeliassortService } from './service/deli-assort/deli-assort.service';
import { DeliassorterrorService } from './service/deli-assort-error/deli-assort-error.service';
import { DeliPriceService } from './service/deli-price/deli-price.service';
import { DeliRouteService } from './service/deli-route/deli-route.service';
import { DeliTimeService } from './service/deli-time/deli-time.service';
import { DialogsService } from '../component/dialog/dialogs.service';
import { DtAddressService } from './service/dt-address/dt-address.service';
import { ExpenseService } from './service/expense/expense.service';
import { HttpService } from './service/http/http.service';
import { InstockService } from './service/instock/instock.service';
import { InterfaceMappingService } from './service/interface-mapping/interface-mapping.service';
import { InventoryService } from './service/inventory/inventory.service';
import { InventoryStockService } from './service/inventory-stock/inventory-stock.service';
import { ItemService } from './service/item/item.service';
import { ItemSetService } from './service/item-set/item-set.service';
import { ItemStockService } from './service/item-stock/item-stock.service';
import { LocaService } from './service/loca/loca.service';
import { LocaBlockService } from './service/loca-block/loca-block.service';
import { LocaStockService } from './service/loca-stock/loca-stock.service';
import { LogicalwhService } from './service/logicalwh/logicalwh.service';
import { MonthlyProcessService } from './service/monthly-process/monthly-process.service';
import { MoveService } from './service/move/move.service';
import { NSuppService } from './service/nsupp/nsupp.service';
import { OwnerService } from './service/owner/owner.service';
import { OwnerFunctionService } from './service/owner-function/owner-function.service';
import { OwnerCarrierService } from './service/owner-carrier/owner-carrier.service';
import { PdfReportService } from './service/pdf-report/pdf-report.service';
import { PickService } from './service/pick/pick.service';
import { PollingService } from './service/polling/polling.service';
import { PrefService } from './service/pref/pref.service';
import { PrintagentService } from './service/printagent/printagent.service';
import { ReqnoService } from './service/reqno/reqno.service';
import { ResultMailService } from './service/result-mail/result-mail.service';
import { RoleService } from './service/role/role.service';
import { SagawaEhidenService } from './service/sagawa-ehiden/sagawa-ehiden.service';
import { SalesCategoryService } from './service/sales-category/sales-category.service';
import { SalesGroupService } from './service/sales-group/sales-group.service';
import { SalesGroupOwnerService } from './service/sales-group-owner/sales-group-owner.service';
import { SalesofficeService } from './service/salesoffice/salesoffice.service';
import { ShipService } from './service/ship/ship.service';
import { ShipApplyLogService } from './service/ship-apply-log/ship-apply-log.service';
import { ShipCaseService } from './service/ship-case/ship-case.service';
import { ShipDeliService } from './service/ship-deli/ship-deli.service';
import { ShipDetailService } from './service/ship-detail/ship-detail.service';
import { ShipInvoiceService } from './service/ship-invoice/ship-invoice.service';
import { SizeService } from './service/size/size.service';
import { StInstockService } from './service/st-instock/st-instock.service';
import { StockService } from './service/stock/stock.service';
import { StockInoutService } from './service/stock-inout/stock-inout.service';
import { StPickService } from './service/st-pick/st-pick.service';
import { StShipService } from './service/st-ship/st-ship.service';
import { SuppService } from './service/supp/supp.service';
import { TypeColdService } from './service/type-cold/type-cold.service';
import { TypeItemService } from './service/type-item/type-item.service';
import { TypeOperationService } from './service/type-operation/type-operation.service';
import { TypePrintDeliService } from './service/type-print-deli/type-print-deli.service';
import { TypeShipInvoiceService } from './service/type-shipinvoice/type-shipinvoice.service';
import { TypeStockService } from './service/type-stock/type-stock.service';
import { TypeTaxService } from './service/type-tax/type-tax.service';
import { TypeunitpriceService } from './service/typeunitprice/typeunitprice.service';
import { UnitService } from './service/unit/unit.service';
import { UserService } from './service/user/user.service';
import { WeightService } from './service/weight/weight.service';
import { WhService } from './service/wh/wh.service';
import { ShelfService } from './service/shelf/shelf.service';
import { ShelfcaseService } from './service/shelfcase/shelfcase.service';
import { CodeVarcharService } from './service/code-varchar/codevarchar-service';
import { CodeIntService } from './service/code-int/codeint-service';
import { MaShipcaseService } from './service/mashipcase/mashipcase.service';
import { PickcaseService } from './service/pickcase/pickcase.service';
import { CarrierdeviceService } from './service/carrierdevice/carrierdevice.service';
// custom component
import { AppComponent } from './app.component';
import { CustomConfirmDialogComponent } from '../component/dialog/app-custom-confirm-dialog.component';
import { ConfirmDialog } from '../component/dialog/confirm-dialog.component';
import { InfoDialog } from '../component/dialog/info-dialog.component';
import { ErrorInfoComponent } from '../component/error-info.component';
import { HeaderComponent } from './menu/header/header.component';
import { NavbarComponent } from './menu/navbar/navbar.component';
import { SidemenuComponent } from './menu/sidemenu/sidemenu.component';
import { Wa0001Component } from './pages/wa0Common/wa0001/wa0001.component';
import { Wa0002Component } from './pages/wa0Common/wa0002/wa0002.component';
import { Wa0003Component } from './pages/wa0Common/wa0003/wa0003.component';
import { Wa0010Component } from './pages/wa0Common/wa0010/wa0010.component';
import { Wa0020Component } from './pages/wa0Common/wa0020/wa0020.component';
import { Wa0030Component } from './pages/wa0Common/wa0030/wa0030.component';
import { Wa0040Component } from './pages/wa0Common/wa0040/wa0040.component';
import { Wa0050Component } from './pages/wa0Common/wa0050/wa0050.component';
import { Wa0051Component } from './pages/wa0Common/wa0051/wa0051.component';
import { Wa0052Component } from './pages/wa0Common/wa0052/wa0052.component';
import { Wa0053Component } from './pages/wa0Common/wa0053/wa0053.component';
import { Wa0054Component } from './pages/wa0Common/wa0054/wa0054.component';
import { Wa1000Component } from './pages/wa1Arrival/wa1000/wa1000.component';
import { Wa1010Component } from './pages/wa1Arrival/wa1010/wa1010.component';
import { Wa1012Component } from './pages/wa1Arrival/wa1012/wa1012.component';
import { Wa1013Component } from './pages/wa1Arrival/wa1013/wa1013.component';
import { Wa1014Component } from './pages/wa1Arrival/wa1014/wa1014.component';
import { Wa1020Component } from './pages/wa1Arrival/wa1020/wa1020.component';
import { Wa1030Component } from './pages/wa1Arrival/wa1030/wa1030.component';
import { Wa1031Component } from './pages/wa1Arrival/wa1031/wa1031.component';
import { Wa1910Component } from './pages/wa1Arrival/wa1910/wa1910.component';
import { Wa3000Component } from './pages/wa3Shipment/wa3000/wa3000.component';
import { Wa3010Component } from './pages/wa3Shipment/wa3010/wa3010.component';
import { Wa3011Component } from './pages/wa3Shipment/wa3011/wa3011.component';
import { Wa3013Component } from './pages/wa3Shipment/wa3013/wa3013.component';
import { Wa3014Component } from './pages/wa3Shipment/wa3014/wa3014.component';
import { Wa3015Component } from './pages/wa3Shipment/wa3015/wa3015.component';
import { Wa3016Component } from './pages/wa3Shipment/wa3016/wa3016.component';
import { Wa3017Component } from './pages/wa3Shipment/wa3017/wa3017.component';
import { Wa3020Component } from './pages/wa3Shipment/wa3020/wa3020.component';
import { Wa3030Component } from './pages/wa3Shipment/wa3030/wa3030.component';
import { Wa3040Component } from './pages/wa3Shipment/wa3040/wa3040.component';
import { Wa3041Component } from './pages/wa3Shipment/wa3041/wa3041.component';
import { Wa3042Component } from './pages/wa3Shipment/wa3042/wa3042.component';
import { Wa3050Component } from './pages/wa3Shipment/wa3050/wa3050.component';
import { Wa3051Component } from './pages/wa3Shipment/wa3051/wa3051.component';
import { Wa3053Component } from './pages/wa3Shipment/wa3053/wa3053.component';
import { Wa3910Component } from './pages/wa3Shipment/wa3910/wa3910.component';
import { Wa3921Component } from './pages/wa3Shipment/wa3921/wa3921.component';
import { Wa3922Component } from './pages/wa3Shipment/wa3922/wa3922.component';
import { Wa5010Component } from './pages/wa5Move/wa5010/wa5010.component';
import { Wa5011Component } from './pages/wa5Move/wa5011/wa5011.component';
import { Wa5020Component } from './pages/wa5Move/wa5020/wa5020.component';
import { Wa5030Component } from './pages/wa5Move/wa5030/wa5030.component';
import { Wa6010Component } from './pages/wa6Stock/wa6010/wa6010.component';
import { Wa6011Component } from './pages/wa6Stock/wa6011/wa6011.component';
import { Wa6012Component } from './pages/wa6Stock/wa6012/wa6012.component';
import { Wa6013Component } from './pages/wa6Stock/wa6013/wa6013.component';
import { Wa6014Component } from './pages/wa6Stock/wa6014/wa6014.component';
import { Wa6020Component } from './pages/wa6Stock/wa6020/wa6020.component';
import { Wa6022Component } from './pages/wa6Stock/wa6022/wa6022.component';
import { Wa6030Component } from './pages/wa6Stock/wa6030/wa6030.component';
import { Wa6040Component } from './pages/wa6Stock/wa6040/wa6040.component';
import { Wa6050Component } from './pages/wa6Stock/wa6050/wa6050.component';
import { Wa6060Component } from './pages/wa6Stock/wa6060/wa6060.component';
import { Wa7010Component } from './pages/wa7Inventory/wa7010/wa7010.component';
import { Wa7011Component } from './pages/wa7Inventory/wa7011/wa7011.component';
import { Wa8001Component } from './pages/wa8Billing/wa8001/wa8001.component';
import { Wa8002Component } from './pages/wa8Billing/wa8002/wa8002.component';
import { Wa8003Component } from './pages/wa8Billing/wa8003/wa8003.component';
import { Wa8004Component } from './pages/wa8Billing/wa8004/wa8004.component';
import { Wa8005Component } from './pages/wa8Billing/wa8005/wa8005.component';
import { Wa8006Component } from './pages/wa8Billing/wa8006/wa8006.component';
import { Wa8010Component } from './pages/wa8Billing/wa8010/wa8010.component';
import { Wa8011Component } from './pages/wa8Billing/wa8011/wa8011.component';
import { Wa8012Component } from './pages/wa8Billing/wa8012/wa8012.component';
import { Wa8013Component } from './pages/wa8Billing/wa8013/wa8013.component';
import { Wa8014Component } from './pages/wa8Billing/wa8014/wa8014.component';
import { Wa9001Component } from './pages/wa9Master/wa9001/wa9001.component';
import { Wa9002Component } from './pages/wa9Master/wa9002/wa9002.component';
import { Wa9003Component } from './pages/wa9Master/wa9003/wa9003.component';
import { Wa9004Component } from './pages/wa9Master/wa9004/wa9004.component';
import { Wa9005Component } from './pages/wa9Master/wa9005/wa9005.component';
import { Wa9100Component } from './pages/wa9Master/wa9100/wa9100.component';
import { Wa9101Component } from './pages/wa9Master/wa9101/wa9101.component';
import { Wa9102Component } from './pages/wa9Master/wa9102/wa9102.component';
import { Wa9104Component } from './pages/wa9Master/wa9104/wa9104.component';
import { Wa9105Component } from './pages/wa9Master/wa9105/wa9105.component';
import { Wa9120Component } from './pages/wa9Master/wa9120/wa9120.component';
import { Wa9121Component } from './pages/wa9Master/wa9121/wa9121.component';
import { Wa9122Component } from './pages/wa9Master/wa9122/wa9122.component';
import { Wa9123Component } from './pages/wa9Master/wa9123/wa9123.component';
import { Wa9124Component } from './pages/wa9Master/wa9124/wa9124.component';
import { Wa9125Component } from './pages/wa9Master/wa9125/wa9125.component';
import { Wa9140Component } from './pages/wa9Master/wa9140/wa9140.component';
import { Wa9141Component } from './pages/wa9Master/wa9141/wa9141.component';
import { Wa9142Component } from './pages/wa9Master/wa9142/wa9142.component';
import { Wa9143Component } from './pages/wa9Master/wa9143/wa9143.component';
import { Wa9144Component } from './pages/wa9Master/wa9144/wa9144.component';
import { Wa9150Component } from './pages/wa9Master/wa9150/wa9150.component';
import { Wa9151Component } from './pages/wa9Master/wa9151/wa9151.component';
import { Wa9160Component } from './pages/wa9Master/wa9160/wa9160.component';
import { Wa9161Component } from './pages/wa9Master/wa9161/wa9161.component';
import { Wa9162Component } from './pages/wa9Master/wa9162/wa9162.component';
import { Wa9163Component } from './pages/wa9Master/wa9163/wa9163.component';
import { Wa9164Component } from './pages/wa9Master/wa9164/wa9164.component';
import { Wa9165Component } from './pages/wa9Master/wa9165/wa9165.component';
import { Wa9166Component } from './pages/wa9Master/wa9166/wa9166.component';
import { Wa9167Component } from './pages/wa9Master/wa9167/wa9167.component';
import { Wa9168Component } from './pages/wa9Master/wa9168/wa9168.component';
import { Wa9170Component } from './pages/wa9Master/wa9170/wa9170.component';
import { Wa9171Component } from './pages/wa9Master/wa9171/wa9171.component';
import { Wa9172Component } from './pages/wa9Master/wa9172/wa9172.component';
import { Wa9173Component } from './pages/wa9Master/wa9173/wa9173.component';
import { Wa9174Component } from './pages/wa9Master/wa9174/wa9174.component';
import { Wa9175Component } from './pages/wa9Master/wa9175/wa9175.component';
import { Wa9180Component } from './pages/wa9Master/wa9180/wa9180.component';
import { Wa9181Component } from './pages/wa9Master/wa9181/wa9181.component';
import { Wa9182Component } from './pages/wa9Master/wa9182/wa9182.component';
import { Wa9183Component } from './pages/wa9Master/wa9183/wa9183.component';
import { Wa9191Component } from './pages/wa9Master/wa9191/wa9191.component';
import { Wa9192Component } from './pages/wa9Master/wa9192/wa9192.component';
import { Wa9193Component } from './pages/wa9Master/wa9193/wa9193.component';
import { Wa9201Component } from './pages/wa9Master/wa9201/wa9201.component';
import { Wa9211Component } from './pages/wa9Master/wa9211/wa9211.component';
import { Wa9212Component } from './pages/wa9Master/wa9212/wa9212.component';
import { Wa9213Component } from './pages/wa9Master/wa9213/wa9213.component';
import { Wa9214Component } from './pages/wa9Master/wa9214/wa9214.component';
import { Wa9215Component } from './pages/wa9Master/wa9215/wa9215.component';
import { Wa9216Component } from './pages/wa9Master/wa9216/wa9216.component';
import { Wa9217Component } from './pages/wa9Master/wa9217/wa9217.component';
import { Wa9218Component } from './pages/wa9Master/wa9218/wa9218.component';
import { Wa9219Component } from './pages/wa9Master/wa9219/wa9219.component';
import { Wa9221Component } from './pages/wa9Master/wa9221/wa9221.component';
import { Wa9222Component } from './pages/wa9Master/wa9222/wa9222.component';
import { Wa9231Component } from './pages/wa9Master/wa9231/wa9231.component';
import { Wa9232Component } from './pages/wa9Master/wa9232/wa9232.component';
import { Wa9233Component } from './pages/wa9Master/wa9233/wa9233.component';
import { Wa9240Component } from './pages/wa9Master/wa9240/wa9240.component';
import { Wa9241Component } from './pages/wa9Master/wa9241/wa9241.component';
import { Wa9242Component } from './pages/wa9Master/wa9242/wa9242.component';
import { Wa9243Component } from './pages/wa9Master/wa9243/wa9243.component';
import { Wa9244Component } from './pages/wa9Master/wa9244/wa9244.component';
import { Wa9245Component } from './pages/wa9Master/wa9245/wa9245.component';
import { Wa9251Component } from './pages/wa9Master/wa9251/wa9251.component';
import { Wa9252Component } from './pages/wa9Master/wa9252/wa9252.component';
import { Wa9253Component } from './pages/wa9Master/wa9253/wa9253.component';

export { NgbDropdownModule, NgbDropdownConfig, NgbDropdown } from './dropdown/dropdown.module';
export { NgbAccordionModule, NgbPanelChangeEvent, NgbAccordionConfig, NgbAccordion, NgbPanel, NgbPanelTitle, NgbPanelContent } from './accordion/accordion.module';

@NgModule({
  declarations: [
    AppComponent,
    ConfirmDialog,
    CustomConfirmDialogComponent,
    InfoDialog,
    ErrorInfoComponent,
    HeaderComponent,
    NavbarComponent,
    SidemenuComponent,
    GridButtonRenderComponent,
    GridSelectRendererComponent,
    GridDoubleButtonRendererComponent,
    Wa0001Component,
    Wa0002Component,
    Wa0003Component,
    Wa0010Component,
    Wa0020Component,
    Wa0030Component,
    Wa0040Component,
    Wa0050Component,
    Wa0051Component,
    Wa0052Component,
    Wa0053Component,
    Wa0054Component,
    Wa1000Component,
    Wa1010Component,
    Wa1012Component,
    Wa1013Component,
    Wa1014Component,
    Wa1020Component,
    Wa1030Component,
    Wa1031Component,
    Wa1910Component,
    Wa3000Component,
    Wa3010Component,
    Wa3011Component,
    Wa3013Component,
    Wa3014Component,
    Wa3015Component,
    Wa3016Component,
    Wa3017Component,
    Wa3020Component,
    Wa3030Component,
    Wa3040Component,
    Wa3041Component,
    Wa3042Component,
    Wa3050Component,
    Wa3051Component,
    Wa3053Component,
    Wa3910Component,
    Wa3921Component,
    Wa3922Component,
    Wa5010Component,
    Wa5011Component,
    Wa5020Component,
    Wa5030Component,
    Wa6010Component,
    Wa6011Component,
    Wa6012Component,
    Wa6013Component,
    Wa6014Component,
    Wa6020Component,
    Wa6022Component,
    Wa6030Component,
    Wa6040Component,
    Wa6050Component,
    Wa6060Component,
    Wa7010Component,
    Wa7011Component,
    Wa8001Component,
    Wa8002Component,
    Wa8003Component,
    Wa8004Component,
    Wa8005Component,
    Wa8006Component,
    Wa8010Component,
    Wa8011Component,
    Wa8012Component,
    Wa8013Component,
    Wa8014Component,
    Wa9001Component,
    Wa9002Component,
    Wa9003Component,
    Wa9004Component,
    Wa9005Component,
    Wa9100Component,
    Wa9101Component,
    Wa9102Component,
    Wa9104Component,
    Wa9105Component,
    Wa9120Component,
    Wa9121Component,
    Wa9122Component,
    Wa9123Component,
    Wa9124Component,
    Wa9125Component,
    Wa9140Component,
    Wa9141Component,
    Wa9142Component,
    Wa9143Component,
    Wa9144Component,
    Wa9150Component,
    Wa9151Component,
    Wa9160Component,
    Wa9161Component,
    Wa9162Component,
    Wa9163Component,
    Wa9164Component,
    Wa9165Component,
    Wa9166Component,
    Wa9167Component,
    Wa9168Component,
    Wa9170Component,
    Wa9171Component,
    Wa9172Component,
    Wa9173Component,
    Wa9174Component,
    Wa9175Component,
    Wa9180Component,
    Wa9181Component,
    Wa9182Component,
    Wa9183Component,
    Wa9191Component,
    Wa9192Component,
    Wa9193Component,
    Wa9201Component,
    Wa9211Component,
    Wa9212Component,
    Wa9213Component,
    Wa9214Component,
    Wa9215Component,
    Wa9216Component,
    Wa9217Component,
    Wa9218Component,
    Wa9219Component,
    Wa9221Component,
    Wa9222Component,
    Wa9231Component,
    Wa9232Component,
    Wa9233Component,
    Wa9240Component,
    Wa9241Component,
    Wa9242Component,
    Wa9243Component,
    Wa9244Component,
    Wa9245Component,
    Wa9251Component,
    Wa9252Component,
    Wa9253Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    RouterModule,
    // grid
    AgGridModule.withComponents([]),
    // Dropdown
    NgbDropdownModule.forRoot(),
    // Accordion
    NgbAccordionModule.forRoot(),
    // FileUpload
    FileUploadModule,
    // Material Design
    BrowserAnimationsModule,
    MdButtonModule,
    MdCardModule,
    MdCheckboxModule,
    MdDialogModule,
    MdIconModule,
    MdInputModule,
    MdListModule,
    MdRadioModule,
    MdSelectModule,
    MdSidenavModule,
    MdTabsModule,
    MdToolbarModule,
    MdProgressBarModule,
    MdAutocompleteModule,
    MdDatepickerModule,
    MdNativeDateModule,
    MdTooltipModule,
    AgGridModule.withComponents([GridButtonRenderComponent, GridSelectRendererComponent, GridDoubleButtonRendererComponent])
    // file uploader
    //    FileUploader,
  ],
  exports: [
    ConfirmDialog,
    CustomConfirmDialogComponent,
    InfoDialog,
    MdAutocompleteModule,
    MdDatepickerModule,
    MdNativeDateModule,
    MdProgressBarModule,
    NgbAccordionModule,
    NgbDropdownModule,
    Wa0050Component,
    Wa0051Component,
    Wa0052Component,
    Wa0053Component,
    Wa0054Component,
    Wa3053Component,
  ],
  providers: [
    AbcService,
    AccountBookService,
    AuthHashkeyService,
    AuthLoginService,
    AuthLogoutService,
    AuthRefreshService,
    ArrivePlanService,
    ArriveResultService,
    BookStockService,
    CarrierService,
    CaseService,
    ClientReportService,
    CommonService,
    CreateFormService,
    CsvReportService,
    DeliAreaService,
    DeliassortService,
    DeliassorterrorService,
    DeliPriceService,
    DeliRouteService,
    DeliTimeService,
    DialogsService,
    DtAddressService,
    ExpenseService,
    HttpService,
    InstockService,
    InterfaceMappingService,
    InventoryService,
    InventoryStockService,
    ItemService,
    ItemSetService,
    ItemStockService,
    LocaService,
    LocaBlockService,
    LocaStockService,
    LogicalwhService,
    MdNativeDateModule,
    MonthlyProcessService,
    MoveService,
    NSuppService,
    OwnerService,
    OwnerFunctionService,
    OwnerCarrierService,
    PdfReportService,
    PickService,
    PollingService,
    PrefService,
    PrintagentService,
    ReqnoService,
    ResultMailService,
    RoleService,
    SagawaEhidenService,
    SalesCategoryService,
    SalesGroupService,
    SalesGroupOwnerService,
    SalesofficeService,
    ShipService,
    ShipApplyLogService,
    ShipCaseService,
    ShipDeliService,
    ShipDetailService,
    ShipInvoiceService,
    SizeService,
    StInstockService,
    StockService,
    StockInoutService,
    StPickService,
    StShipService,
    SuppService,
    TypeColdService,
    TypeItemService,
    TypeOperationService,
    TypePrintDeliService,
    TypeShipInvoiceService,
    TypeStockService,
    TypeTaxService,
    TypeunitpriceService,
    UnitService,
    UserService,
    WeightService,
    WhService,
    ShelfcaseService,
    ShelfService,
    CodeVarcharService,
    CodeIntService,
    MaShipcaseService,
    PickcaseService,
    CarrierdeviceService,
  ],
  entryComponents: [ConfirmDialog, InfoDialog, CustomConfirmDialogComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
export class DialogsModule { }



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/app.module.ts